import UserService from 'Services/user';

export default {
	name: 'account-invoices-modal',
	created() {
		this.isLoading = true;
		UserService.getInvoices()
			.then(response => {
				this.invoices = response.data;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isLoading: false,
			invoices: []
		};
	},
	methods: {
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.push('/account');
			}
		},
		downloadInvoice(id) {
			UserService.openInvoiceInPDF(id);
		}
	},
	filters: {
		timeConverter: function(timestamp) {
			var a = new Date(timestamp * 1000);
			var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			var year = a.getFullYear();
			var month = months[a.getMonth()];
			var day = a.getDate();
			var date = month + ' ' + day + ', ' + year;
			return date;
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/account-invoices-modal/script.js